import {
  Redirect, Route, Switch, useLanguage, withRouter,
} from '@ipc/ipc-core';
import { Notifications } from '@ipc/ipc-components';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Login from '../common/Login';
import NotFound from '../common/NotFound';
import { AppContentStyle } from './AppContent.styles';
import Home from '../common/Home';
import PrivateRoute from '../common/PrivateRoute';
import { NotificationsAdapter } from '../common/notifications/components/NotificationsAdapter';
import { getNotification } from '../common/notifications/redux/selectors/NotificationSelector';
import { getAuthState } from '../common/redux/selectors/authInfoSelector';
import MrdDeviceWizard from './mrd-administration/device-information/containers/MrdDeviceWizard';

const StyledAppContent = styled.div`${AppContentStyle}`;

export const AppContent = () => {
  const [, language] = useLanguage();
  const notification = useSelector(getNotification);
  const auth = useSelector(getAuthState);

  const forceReloadCache = async () => {
    window.history.go(0);
  };

  const cachedVersion = process.env.REACT_APP_CACHE_VERSION;
  const localCachedVersion = window.localStorage.getItem('cachedVersion');
  if (localCachedVersion !== cachedVersion) {
    forceReloadCache().then(() => window.localStorage.setItem('cachedVersion', cachedVersion));
  }

  return (
    <>
      <div>
        <NotificationsAdapter notification={notification} auth={auth} />
        <Notifications />
      </div>
      <Switch>
        <Route exact path={language('/login')}>
          <Route component={Login} />
        </Route>
        <Route exact path="/" render={() => <Redirect to={`/${language('monitoring')}`} />} />
        <Route exact path={language('/')} render={() => <Redirect to={`/${language('monitoring')}`} />} />
        <Route>
          <StyledAppContent>
            <Switch>
              <PrivateRoute exact path={language('/home')} component={Home} />
              <PrivateRoute exact path={language('/monitoring')} component={() => <Home withURL="/monitoring/all-mrds" />} />
              <PrivateRoute exact path={language('/monitoring/all-mrds')} component={() => <Home withURL="/monitoring/all-mrds" />} />
              <PrivateRoute exact path={language('/monitoring/all-issues')} component={() => <Home withURL="/monitoring/all-issues" />} />
              <PrivateRoute exact path={language('/monitoring/user-reported')} component={() => <Home withURL="/monitoring/user-reported" />} />
              <PrivateRoute exact path={language('/monitoring/xml-delayed')} component={() => <Home withURL="/monitoring/xml-delayed" />} />
              <PrivateRoute exact path={language('/monitoring/no-sync')} component={() => <Home withURL="/monitoring/no-sync" />} />
              <PrivateRoute exact path={language('/administration')} component={() => <Home withURL="/administration/device-info" />} />
              <PrivateRoute exact path={language('/administration/device-info')} component={() => <Home withURL="/administration/device-info" />} />
              <PrivateRoute exact path={language('/administration/device-settings')} component={() => <Home withURL="/administration/device-settings" />} />
              <PrivateRoute exact path={language('/administration/flights')} component={() => <Home withURL="/administration/flights" />} />
              <PrivateRoute exact path={language('/administration/handlers')} component={() => <Home withURL="/administration/handlers" />} />
              <PrivateRoute exact path={language('/administration/data-sharing')} component={() => <Home withURL="/administration/data-sharing" />} />
              <PrivateRoute exact path={language('/administration/mrd-contact')} component={() => <Home withURL="/administration/mrd-contact" />} />
              <PrivateRoute exact path={language('/administration/mrd-app-translation')} component={() => <Home withURL="/administration/mrd-app-translation" />} />
              <PrivateRoute exact path={language('/administration/notification-service')} component={() => <Home withURL="/administration/notification-service" />} />
              <PrivateRoute exact path={language('/administration/impc-mapping')} component={() => <Home withURL="/administration/impc-mapping" />} />
              <PrivateRoute exact path={language('/add-mrd')} render={(props) => (<MrdDeviceWizard {...props} />)} />
              <Route component={NotFound} />
            </Switch>
          </StyledAppContent>
        </Route>
      </Switch>
    </>
  );
};

export default withRouter(AppContent);
